"use strict";
const crypto = require('crypto');
const ALGORITHM = 'aes-256-cbc';
const ENCODING = 'hex';
const encrypt = (text, key, vectorString) => {
    let iv;
    if (vectorString) {
        if (typeof vectorString === 'string' && vectorString.length === 16) {
            const encoder = new TextEncoder();
            iv = encoder.encode(vectorString);
        }
        else {
            const errorMessage = 'Recieved vector string from outside that does not apply the rule (must be string with length = 16)';
            throw new Error(errorMessage);
        }
    }
    else {
        iv = crypto.randomBytes(16);
    }
    const cipher = crypto.createCipheriv(ALGORITHM, Buffer.from(key), iv);
    let encrypted = cipher.update(text);
    encrypted = Buffer.concat([encrypted, cipher.final()]);
    return { encryptionKey: iv.toString(ENCODING), encryptedData: encrypted.toString(ENCODING) };
};
const decrypt = (iv, encryptedData, key) => {
    const encryptedText = Buffer.from(encryptedData, ENCODING);
    let uintIv = iv;
    if (typeof iv === 'string' && iv.length === 16) {
        const encoder = new TextEncoder();
        uintIv = encoder.encode(iv);
    }
    const decipher = crypto.createDecipheriv(ALGORITHM, Buffer.from(key), Buffer.from(uintIv, ENCODING));
    let decrypted = decipher.update(encryptedText);
    decrypted = Buffer.concat([decrypted, decipher.final()]);
    return decrypted.toString();
};
module.exports = {
    encrypt,
    decrypt,
};
//# sourceMappingURL=cryptoService.js.map